import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Skeleton } from "@/components/ui/skeleton";
import { useFlightSearch } from "@/hooks/flight/useFlightSearch";
import { formatToRupee } from "@/lib/internalApis";
import { FareDetails, TotalPriceInfo } from "@/types/search/flight";
import { useEffect, useState } from "react";

export function FareDialog({
  selectedFare,
  totalPriceInfo,
  fareRule
}: any) {


  const { isFareRuleLoading } = useFlightSearch();



  // const handleFareRule = (selectedFare: TotalPriceInfo) => {
  //   if (selectedFare?.id) {
  //     getFareRules({ id: selectedFare?.id, flowType: "SEARCH" }).then((data) => {
  //       setCurrentFareRule(data);
  //     });
  //   }
  // };





  const getFareDetails = (fareRule: any, key: string) => {
    // If fr data exists, use it directly
    if (fareRule.fareRule[key].fr) {
      return {
        cancellation: {
          amount:
            fareRule.fareRule[key].fr?.CANCELLATION?.DEFAULT?.amount ||
            fareRule.fareRule[key].fr?.CANCELLATION?.BEFORE_DEPARTURE?.amount ||
            fareRule.fareRule[key].fr?.CANCELLATION?.AFTER_DEPARTURE?.amount ||
            0,
          policyInfo:
            fareRule.fareRule[key].fr?.CANCELLATION?.DEFAULT?.policyInfo ||
            fareRule.fareRule[key].fr?.CANCELLATION?.BEFORE_DEPARTURE
              ?.policyInfo ||
            fareRule.fareRule[key].fr?.CANCELLATION?.AFTER_DEPARTURE
              ?.policyInfo,
          additionalFee:
            fareRule.fareRule[key].fr?.CANCELLATION?.DEFAULT?.additionalFee ||
            fareRule.fareRule[key].fr?.CANCELLATION?.BEFORE_DEPARTURE
              ?.additionalFee ||
            fareRule.fareRule[key].fr?.CANCELLATION?.AFTER_DEPARTURE
              ?.additionalFee,
        },
        dateChange: {
          amount:
            fareRule.fareRule[key].fr?.DATECHANGE?.DEFAULT?.amount ??
            fareRule.fareRule[key].fr?.DATECHANGE?.BEFORE_DEPARTURE?.amount ??
            fareRule.fareRule[key].fr?.DATECHANGE?.AFTER_DEPARTURE?.amount ??
            0,
          policyInfo:
            fareRule.fareRule[key].fr?.DATECHANGE?.DEFAULT?.policyInfo ||
            fareRule.fareRule[key].fr?.DATECHANGE?.BEFORE_DEPARTURE
              ?.policyInfo ||
            fareRule.fareRule[key].fr?.DATECHANGE?.AFTER_DEPARTURE?.policyInfo,
          additionalFee:
            fareRule.fareRule[key].fr?.DATECHANGE?.DEFAULT?.additionalFee ||
            fareRule.fareRule[key].fr?.DATECHANGE?.BEFORE_DEPARTURE
              ?.additionalFee ||
            fareRule.fareRule[key].fr?.DATECHANGE?.AFTER_DEPARTURE
              ?.additionalFee,
        },
        noShow: {
          policyInfo:
            fareRule.fareRule[key].fr?.NO_SHOW?.BEFORE_DEPARTURE?.policyInfo ||
            fareRule.fareRule[key].fr?.NO_SHOW?.AFTER_DEPARTURE?.policyInfo,
          additionalFee:
            fareRule.fareRule[key].fr?.NO_SHOW?.BEFORE_DEPARTURE
              ?.additionalFee ||
            fareRule.fareRule[key].fr?.NO_SHOW?.AFTER_DEPARTURE?.additionalFee,
        },
      };
    }

    // If tfr data exists, use it
    if (fareRule.fareRule[key].tfr) {
      return {
        cancellation: {
          amount:
            fareRule.fareRule[key].tfr?.CANCELLATION?.[0]?.additionalFee || 0,
          policyInfo: fareRule.fareRule[key].tfr?.CANCELLATION?.[0]?.policyInfo,
          additionalFee:
            fareRule.fareRule[key].tfr?.CANCELLATION?.[0]?.additionalFee || 0,
        },
        dateChange: {
          amount:
            fareRule.fareRule[key].tfr?.DATECHANGE?.[0]?.additionalFee || 0,
          policyInfo: fareRule.fareRule[key].tfr?.DATECHANGE?.[0]?.policyInfo,
          additionalFee:
            fareRule.fareRule[key].tfr?.DATECHANGE?.[0]?.additionalFee || 0,
        },
        noShow: {
          policyInfo: fareRule.fareRule[key].tfr?.NO_SHOW?.[0]?.policyInfo,
          additionalFee:
            fareRule.fareRule[key].tfr?.NO_SHOW?.[0]?.additionalFee || 0,
        },
      };
    }

    // Return default empty values if neither exists
    return {
      cancellation: { amount: 0, policyInfo: "", additionalFee: 0 },
      dateChange: { amount: 0, policyInfo: "", additionalFee: 0 },
      noShow: { policyInfo: "", additionalFee: 0 },
    };
  };

  return (
    <Dialog>
      <form>
        <DialogTrigger asChild>
          <span
            className="cursor-pointer text-[9px] md:text-sm text-muted-foreground"
          // onClick={() =>
          //   handleFareRule(selectedFare)
          // }
          >
            Fare Rules
          </span>
        </DialogTrigger>
        <DialogContent className="sm:max-w-[600px]">
          <DialogHeader>
            <DialogTitle>Fare Rules</DialogTitle>
          </DialogHeader>
          <div>
            {isFareRuleLoading ? (
              <div className="p-5 bg-[#e9e9e9] space-y-4">
                <Skeleton className="h-10 w-32" />
                <Skeleton className="h-6 w-24" />
                <div className="space-y-2">
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-3/4" />
                </div>
                <div className="space-y-4">
                  <div className="grid grid-cols-5 gap-4">
                    <Skeleton className="h-8" />
                    <Skeleton className="h-8" />
                    <Skeleton className="h-8" />
                    <Skeleton className="h-8" />
                    <Skeleton className="h-8" />
                  </div>
                  <div className="grid grid-cols-5 gap-4">
                    <Skeleton className="h-20" />
                    <Skeleton className="h-20" />
                    <Skeleton className="h-20" />
                    <Skeleton className="h-20" />
                    <Skeleton className="h-20" />
                  </div>
                </div>
              </div>
            ) : (
              fareRule &&
              Object.keys(fareRule?.fareRule).map((key: any, index: number) => {

                return <div key={index}>
                  <div>
                    <section className="flex flex-col items-center md:flex-row justify-between border">
                      <p className="basis-[25%] text-center py-2 text-gray_dark md:border-r-2">
                        Baggage Information
                      </p>
                      <div className="basis-[75%] text-start ml-2 py-2 text-gray_dark">
                        {totalPriceInfo
                          .filter(
                            (priceInfo: TotalPriceInfo) =>
                              priceInfo.id === selectedFare.id
                          )
                          .map((priceInfo: TotalPriceInfo, index: number) => {
                            // Find the passenger type (ADULT, CHILD, or INFANT) that has baggage info
                            const passengerTypes: Array<keyof FareDetails> = [
                              "ADULT",
                              "CHILD",
                              "INFANT",
                            ];
                            const passengerType = passengerTypes.find(
                              (type) => priceInfo.fd?.[type]?.bI
                            );

                            if (!passengerType) return null; // Skip if no passenger type with baggage info

                            const baggageInfo = priceInfo.fd[passengerType]?.bI;

                            return baggageInfo ? (
                              <p key={index} className="flex flex-col gap-2">
                                <span className="text-[13px] text-gray_dark font-medium ml-2">
                                  {`CHECK-IN: ${passengerType} (${baggageInfo.iB})`}
                                </span>
                                <span className="text-gray_dark text-[13px] font-medium ml-2">
                                  CABIN: {baggageInfo.cB}
                                </span>
                              </p>
                            ) : null;
                          })}
                      </div>
                    </section>
                  </div>
                  <div>
                    {(() => {
                      const details = getFareDetails(fareRule, key);
                      return (
                        <div
                          className="flex flex-col items-center md:flex-row justify-between border"
                          key={index}
                        >
                          <div className="basis-[25%] text-center py-2 text-gray_dark md:border-r-2">
                            Cancellation
                          </div>
                          <div className="basis-[75%] text-start ml-2 py-2 text-gray_dark">
                            {selectedFare?.fareIdentifier === "OFFER_FARE_WITH_PNR" ? "Not Allowed" : `${formatToRupee(details.cancellation.amount + details.cancellation.additionalFee)}+
                            ${details.cancellation.policyInfo?.replaceAll(
                              "__nls__",
                              " "
                            ) ?? ""} Service Fees`}
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                  <div>
                    {(() => {
                      const details = getFareDetails(fareRule, key);
                      return (
                        <div
                          className="flex flex-col items-center md:flex-row justify-between border"
                          key={index}
                        >
                          <div className="basis-[25%] text-center py-2 text-gray_dark md:border-r-2">
                            Date Change
                          </div>
                          <div className="basis-[75%] text-start ml-2 py-2 text-gray_dark">
                            {selectedFare?.fareIdentifier === "OFFER_FARE_WITH_PNR" || selectedFare?.fd?.ADULT?.rT === 0 ? "Not Allowed" : `${formatToRupee(details.dateChange.amount + details.dateChange.additionalFee)}
                            ${details.dateChange.policyInfo?.replaceAll(
                              "__nls__",
                              " "
                            ) ?? ""} + Service Fees`}
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                  <div>
                    {(() => {
                      const details = getFareDetails(fareRule, key);
                      return (
                        <div
                          className="flex flex-col items-center md:flex-row justify-between border"
                          key={index}
                        >
                          <div className="basis-[25%] text-center py-2 text-gray_dark md:border-r-2">
                            Seat Chargeable
                          </div>
                          <div className="basis-[75%] text-start ml-2 py-2 text-gray_dark">
                            {details.noShow.policyInfo?.replaceAll(
                              "__nls__",
                              " "
                            ) || "As Per Airline"}
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                </div>
              })
            )}
          </div>
        </DialogContent>
      </form>
    </Dialog>
  );
}
